import React, { useContext } from 'react';
import { Audience } from "../audience-api";
import { createStore } from "../components/store-utils";


export interface AudienceState {
    audiences?: Audience[]
    audience?: Audience
}

export type AudienceAction = 
    {type:"setAudiences", payload: Audience[]} |
    {type:"setAudience", payload: Audience} |
    {type:"updateAudience", payload: Audience} 


function audienceReducer(state: AudienceState, action: AudienceAction):AudienceState{
    switch(action.type){
        case "setAudience": return {...state, audience: action.payload}
        case "updateAudience": return {...state, audiences: state.audiences.map(a => a.id == action.payload.id ? action.payload : a)  }
        case "setAudiences": return {...state, audiences: action.payload}
    }
}

function createComp(defaultName:string){
    function Hello({name}:{name?:string}){
        if(!name) name = defaultName;
        return <div>{name}</div>
    }

    return Hello;
}

const {Store, StoreProvider} = createStore(audienceReducer, {});
export const AudienceContext = Store;
export const AudienceProvider = StoreProvider;
export function useAudienceContext(){return useContext(AudienceContext).state}
export function useAudience(){return useContext(AudienceContext).state.audience}


export const Tchan = createComp("Hahahha");